import { useState } from "react";

const CARD_BG = "#141720";
const BORDER = "#1e2130";
const TEXT_PRIMARY = "#e8eaf0";
const TEXT_SECONDARY = "#5a5f7a";

export default function Ayarlar() {
  const [bildirimler, setBildirimler] = useState({ yeniBasvuru: true, whatsappTiklama: true, kampanyaGuncelleme: false, haftalikRapor: true });
  const [kaydedildi, setKaydedildi] = useState(false);

  const handleKaydet = () => { setKaydedildi(true); setTimeout(() => setKaydedildi(false), 2000); };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h2 className="text-lg font-bold" style={{ color: TEXT_PRIMARY }}>Ayarlar</h2>
        <p className="text-sm mt-1" style={{ color: TEXT_SECONDARY }}>Panel tercihlerinizi yönetin</p>
      </div>

      <div className="rounded-2xl p-5" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
        <p className="text-sm font-bold mb-4" style={{ color: TEXT_PRIMARY }}>Profil Bilgileri</p>
        <div className="flex items-center gap-4 mb-5">
          <div className="w-14 h-14 rounded-full flex items-center justify-center" style={{ background: "linear-gradient(135deg,#7c3aed,#4f46e5)" }}>
            <span className="text-white text-lg font-bold">AY</span>
          </div>
          <div>
            <p className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>Admin Yönetici</p>
            <p className="text-xs" style={{ color: TEXT_SECONDARY }}>admin@smartpro.com</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[{ label: "Ad Soyad", val: "Admin Yönetici", type: "text" }, { label: "E-posta", val: "admin@smartpro.com", type: "email" }].map((f) => (
            <div key={f.label}>
              <label className="text-xs font-semibold block mb-1.5" style={{ color: TEXT_SECONDARY }}>{f.label}</label>
              <input type={f.type} defaultValue={f.val} className="w-full rounded-xl px-3 py-2.5 text-sm outline-none transition-colors"
                style={{ backgroundColor: "#0d0f16", border: `1px solid ${BORDER}`, color: "#c8cad8" }} />
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-2xl p-5" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
        <p className="text-sm font-bold mb-4" style={{ color: TEXT_PRIMARY }}>Bildirim Tercihleri</p>
        <div className="space-y-4">
          {[
            { key: "yeniBasvuru", label: "Yeni Başvuru", aciklama: "Yeni bir başvuru geldiğinde bildirim al" },
            { key: "whatsappTiklama", label: "WhatsApp Tıklaması", aciklama: "Kullanıcı WhatsApp'a tıkladığında bildirim al" },
            { key: "kampanyaGuncelleme", label: "Kampanya Güncellemesi", aciklama: "Kampanya performansı değiştiğinde bildirim al" },
            { key: "haftalikRapor", label: "Haftalık Rapor", aciklama: "Her Pazartesi haftalık özet raporu al" },
          ].map((item) => (
            <div key={item.key} className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium" style={{ color: TEXT_PRIMARY }}>{item.label}</p>
                <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{item.aciklama}</p>
              </div>
              <button onClick={() => setBildirimler((prev) => ({ ...prev, [item.key]: !prev[item.key as keyof typeof prev] }))}
                className="relative w-11 h-6 rounded-full transition-colors cursor-pointer flex-shrink-0"
                style={{ backgroundColor: bildirimler[item.key as keyof typeof bildirimler] ? "#7c3aed" : "#1e2130" }}>
                <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full transition-transform ${bildirimler[item.key as keyof typeof bildirimler] ? "translate-x-5" : "translate-x-0.5"}`}></span>
              </button>
            </div>
          ))}
        </div>
      </div>

      <button onClick={handleKaydet} className="flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-semibold transition-all cursor-pointer whitespace-nowrap text-white"
        style={{ background: kaydedildi ? "linear-gradient(135deg,#10b981,#059669)" : "linear-gradient(135deg,#7c3aed,#4f46e5)" }}>
        {kaydedildi ? <><i className="ri-check-line"></i>Kaydedildi!</> : <><i className="ri-save-line"></i>Değişiklikleri Kaydet</>}
      </button>
    </div>
  );
}
